import React, { useState } from "react";
import { Layout } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import Cookies from "universal-cookie";
import { Link } from "react-router-dom";
import HomeSider from "./HomePage/HomeSider";
import HomeContent from "./HomePage/HomeContent";
import ImpersonationBanner from "./HomePage/ImpersonationBanner";
import { useSidebar } from "../context/SidebarContext";
import logoImage from "../assets/logo-mediatropy-2024-name.gif";
import "./HomePage.scss";

const HomePage = ({ children }) => {
    const cookies = new Cookies();
    const user = cookies.get("userR");
    const { collapsed, animationEnabled, setCollapsed } = useSidebar();
    const [workStatus, setWorkStatus] = useState(() => {
        const savedStatus = localStorage.getItem("userWorkStatus");
        return savedStatus || "working_home";
    });

    // Extract user information
    const userName = user?.name || user?.email || "User";
    let userRoles = [];
    
    if (user?.roles) {
        const roles = user.roles;
        // Check if it's a PHP serialized format
        if (typeof roles === 'string' && roles.startsWith('a:') && roles.includes('{')) {
            // Parse PHP serialized roles
            const regex = /s:\d+:"(ROLE_[A-Z_]+)"/g;
            let match;
            while ((match = regex.exec(roles)) !== null) {
                userRoles.push(match[1]);
            }
        } else if (Array.isArray(roles)) {
            userRoles = roles;
        } else if (typeof roles === 'string') {
            userRoles = roles.split(',').map(r => r.trim());
        }
    }

    const isImpersonating = cookies.get("isImpersonating");
    const isProduction = process.env.VITE_ENV === 'production';

    // Border color: Red for production, Yellow for dev/test
    const borderColor = isProduction ? '#f44336' : '#FED230';

    return (
        <>
            <ImpersonationBanner />
            {isImpersonating && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    border: `3px solid ${borderColor}`,
                    pointerEvents: 'none',
                    zIndex: 9999
                }} />
            )}
            <header className="hrp-mobile-topbar">
                <Link to="/" className="hrp-mobile-topbar-logo" aria-label="Go to dashboard">
                    <img src={logoImage} alt="Mediatropy" />
                </Link>
                <button
                    type="button"
                    className="hrp-mobile-menu-button"
                    aria-label="Open menu"
                    onClick={() => setCollapsed(false)}
                >
                    <MenuOutlined />
                </button>
            </header>
            {!collapsed && (
                <button
                    type="button"
                    className="hrp-mobile-sidebar-backdrop"
                    aria-label="Close menu"
                    onClick={() => setCollapsed(true)}
                />
            )}
            <Layout className="hrp-app-shell" style={{ minHeight: "100vh", marginTop: isImpersonating ? '32px' : 0 }}>
                <HomeSider
                    collapsed={collapsed}
                    animationEnabled={animationEnabled}
                    userRoles={userRoles}
                    userName={userName}
                    workStatus={workStatus}
                    setWorkStatus={setWorkStatus}
                />
                <Layout>
                    {children || <HomeContent />}
                </Layout>
            </Layout>
        </>
    );
};

export default HomePage;
